module.exports = __webpack_public_path__ + "1e52196c20e9739aaf92c3bb6eec0bbc.pdf";